import type { ServerMsg } from './net-types'

// Table EXHAUSTIVE des discriminants ServerMsg valides. Le type `Record<ServerMsg['type'], true>`
// force l'exhaustivité au COMPILE : si un variant est ajouté à ServerMsg (net-types.ts) sans être
// listé ici, le typecheck échoue (propriété manquante) ; une clé inconnue échoue aussi. La garde
// reste donc automatiquement synchronisée avec le protocole.
const SERVER_MSG_TYPES: Record<ServerMsg['type'], true> = {
  online: true, rooms: true, room_created: true, room_state: true, start: true, snapshot: true,
  pause: true, resume: true, gameover: true, aborted: true, error: true,
}

// Valide la FORME d'un message serveur déjà décodé (post-JSON.parse) : un objet non-nul dont le
// discriminant `type` est un variant connu. Renvoie le message typé, ou `null` si la forme est
// invalide/inconnue — le client l'ignore alors au lieu d'un cast aveugle qui laisserait l'UI lire
// les champs d'un variant fantôme. Ne re-valide PAS les champs internes de chaque variant : le
// serveur (seule source) les garantit et l'UI ne lit que ceux dont elle a besoin ; la garde sur le
// `type` suffit à écarter un message étranger ou corrompu.
export function decodeServerMsg(raw: unknown): ServerMsg | null {
  if (typeof raw !== 'object' || raw === null) return null
  const type = (raw as { type?: unknown }).type
  if (typeof type !== 'string' || !Object.prototype.hasOwnProperty.call(SERVER_MSG_TYPES, type)) return null
  return raw as ServerMsg
}
